import cx from 'classnames';

import {Text} from '#component/base';

import {AuthCTAMessagesProps} from './AuthCTAMessages.types';

import {messageStyles, rootStyles, titleStyles} from './AuthCTAMessages.css';

export const AuthCTAMessages = ({
  title,
  messages = [],
  messageColor,
  titleColor,
  titleVariant,
  className,
}: AuthCTAMessagesProps) => {
  return (
    <div className={cx(rootStyles, className)}>
      <Text
        className={titleStyles}
        variant={!!titleVariant ? titleVariant : 'heading1'}
        color={!!titleColor ? titleColor : 'burgundy'}>
        {title}
      </Text>
      {messages.map((message, index) => (
        <Text
          key={index}
          className={messageStyles}
          color={!!messageColor ? messageColor : 'doveGray'}>
          {message}
        </Text>
      ))}
    </div>
  );
};
